module.exports = __webpack_public_path__ + "static/media/before_service3.b3c48053.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/before_service3.pdf
// module id = 782
// module chunks = 2